<template>
	<div>
		<!-- Desktop login button -->
		<div class="btn-register" v-if="isNativeDevice === false && !isMobileDevice">
			<button v-focus class="btn red" @click="registerNow">
				{{ $t("profile.register") }}
			</button>
		</div>

		<!-- <button v-focus class="btn red" @click="registerNow" v-else-if="isNativeDevice === false && !isMobileDevice">
			{{ $t("profile.register") }}
		</button> -->

		<!-- TV login link -->
		<button v-else-if="isNativeDevice" v-focus class="btn red" @click="tvLogin">{{ $t("profile.register") }}</button>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from "vue"
	import { useRouter } from "vue-router"
	import { useLogin } from "../composables/useLogin"
	import { useDeviceManager } from "../stores/deviceManager"
	import { isNativeDevice, url } from "../helper"
	import { Browser } from "@capacitor/browser"
	import { Capacitor } from "@capacitor/core"
	const deviceManager = useDeviceManager()
	const isMobileDevice = computed(
		() =>
			deviceManager.operatingSystem === "ios" ||
			deviceManager.operatingSystem === "android" ||
			Capacitor.isNativePlatform()
		// () => deviceManager.deviceInfo.platform !== "web"
	)

	const router = useRouter()
	const { login } = useLogin()

	/**
	 * Login button click handler for desktop devices.
	 */
	const loginBtn = async () => {
		sessionStorage.setItem("post_auth_redirect", "/add-profile")
		await login()
	}

	const registerNow = async () => {
		const destination = `${window.location.origin}/auth-check`
		if (Capacitor.isNativePlatform()) {
			await Browser.open({ url: `${url}/el/user/register?destination=${destination}` })
		} else {
			window.location.href = `${url}/el/user/register?destination=${destination}`
		}
	}
	/**
	 * Login button click handler for tv devices.
	 */
	const tvLogin = () => {
		router.push("/login")
	}
</script>

<style scoped lang="scss">
	.btn-register {
		@include br.respond-to(br.$tablet-small) {
			position: fixed;
			background: black;
			bottom: 0;
			z-index: 5;
			left: 0;
			right: 0;
			padding: 20px;
			display: flex;
			justify-content: center;
		}
		button {
			@include br.respond-to(br.$tablet-small) {
				font-size: 18px;
				padding: 4px 16px;
				width: 70vw;
			}
		}
	}
	button {
		flex-shrink: 0;
		border: 1px solid var(--red);
		@extend .vl-font-size--25;

		&:hover {
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
			background: linear-gradient(45deg, var(--red) 0%, #fe4a4a 100%);
		}

		@include br.respond-to(br.$desktop-medium) {
			font-size: 20px;
			padding: 4px 16px;
		}
	}
</style>
